var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-main",class:("type_" + _vm.btnType)},[_c('div',{staticClass:"btn_content"},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('div',{staticClass:"fake_border"})])}
var staticRenderFns = []

export { render, staticRenderFns }